import { Fragment } from "react";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";
import { PremiumChip } from "../PremiumChip";

type Props = {
	accordions: {
		title: string;
		children: React.ReactNode;
	}[];
	showPremiumChip?: boolean;
	showFreeChip?: boolean;
	disabled?: boolean;
	hideSectionHeaders?: boolean;
};

const AccordionListItem = ({
	title,
	children,
	showPremiumChip = false,
	showFreeChip = false,
	disabled,
	hideHeader = false,
}: {
	title: React.ReactNode;
	children: React.ReactNode;
	showPremiumChip?: boolean;
	showFreeChip?: boolean;
	disabled?: boolean;
	hideHeader?: boolean;
}) => {
	return (
		<Box gap={8}>
			{hideHeader ? null : (
				<Box
					alignItems="center"
					justifyContent="space-between"
					flexDirection="row"
				>
					<CustomListSubheader
						enableGutters={false}
						style={{ paddingVertical: 0 }}
					>
						{title}
					</CustomListSubheader>
					{showPremiumChip ? (
						<PremiumChip variant="premium" disabled={disabled} />
					) : null}
					{showFreeChip ? (
						<PremiumChip variant="free" disabled={disabled} />
					) : null}
				</Box>
			)}
			{children}
		</Box>
	);
};

const ListAccordion = ({
	accordions,
	showPremiumChip = false,
	showFreeChip = false,
	disabled,
	hideSectionHeaders = false,
}: Props) => {
	return (
		<>
			{accordions.map(({ title, children }) => {
				return (
					<Fragment key={title}>
						<AccordionListItem
							title={title}
							showPremiumChip={showPremiumChip}
							showFreeChip={showFreeChip}
							disabled={disabled}
							hideHeader={hideSectionHeaders}
						>
							{children}
						</AccordionListItem>
					</Fragment>
				);
			})}
		</>
	);
};

export default ListAccordion;
